module.exports = __webpack_public_path__ + "static/1-867a6405beea51a2ae4134f8e1d36c60.png";